import { TYPES } from "@/view/ProseMirrorNode/ProseMirrorNode.constants";
import getHasOnlyHardBreakChildren from "@/view/ProseMirrorNode/utils/getHasOnlyHardBreakChildren";

/**
 * Gets the current number of nodes of each type.
 * This is tracked so that we can build each node's identifier.
 *
 * @param {object} node
 * @param {object} nodeTypeCount
 * @returns {number} count
 */
const getUpdatedNodeTypeCount = (node, nodeTypeCount) => {
  let { type } = node;

  // The Read page wraps image blocks in paragraphs, so in order to have the right count of paragraphs, we must consider them a paragraph.
  // Images cannot themselves be highlighted, so the image blocks will never need their own identifiers.
  if (node.type === TYPES.imageBlock) {
    type = TYPES.paragraph;
  }

  // If the node has marks, the node will be identified by the type of the first mark.
  if (node.marks?.length) {
    type = node.marks[0].type;
  }

  // The Read page strips out paragraphs and headings containing only hard breaks.
  if (node.type === TYPES.paragraph || node.type === TYPES.heading) {
    const hasOnlyHardBreakChildren = !getHasOnlyHardBreakChildren(node);
    if (!hasOnlyHardBreakChildren) return nodeTypeCount;
  }

  nodeTypeCount[type] = nodeTypeCount[type] ? nodeTypeCount[type] + 1 : 1;

  return nodeTypeCount;
};

export default getUpdatedNodeTypeCount;
